import { useEffect, useRef } from 'react'

const useClickOutside = (ref, callback, ignoreFirstClickEnabled = false) => {
  const ignoreFirstClick = useRef(ignoreFirstClickEnabled)

  const handleClick = (e) => {
    if (ignoreFirstClick.current) {
      ignoreFirstClick.current = false // Desactivar después del primer clic
      return
    }

    if (ref.current && !ref.current.contains(e.target)) {
      callback()
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClick)
    return () => {
      document.removeEventListener('click', handleClick)
    }
  }, [])
}

export default useClickOutside
